/** @format */

import React from "react";

export default function Loader() {
  return <div class="overlay"><div class="loader "></div></div>;
}
